<template>
	<billing-layout>
    	<div class="page-breadcrumb">
    		<div class="row">
    			<div class="col-5 align-self-center">
    				<h4 class="page-title"><i class="fas fa-chart-line"></i> Report Expenses</h4>
    			</div>
    			<div class="col-7 align-self-center">
    				<div class="d-flex align-items-right justify-content-end">
    					<nav aria-label="breadcrumb">
    						<ol class="breadcrumb">
    							<li class="breadcrumb-item">
    								<router-link :to="{ name : 'BillingReport'}" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
    							</li>
    						</ol>
    					</nav>
	                </div>
	            </div>
            </div>
        </div>        
        <div class="container-fluid">
        	<div class="row">
        		<div class="col-12">
        			<div class="card card-body">
        				<div class="row">
        					<div class="col-10">
        						<div class="form-inline">
        							<div class="form-group mb-2">
        								<select class="form-control" v-model="SelectOne">
        									<option value="1">This Year</option>
											<option value="4">Last Year</option>
        									<option value="2">This Month</option>
        									<option value="3">Calendar</option>
        								</select>
        							</div>
        							<div class="form-group mb-2" v-if="SelectOne == 3">
        							 	<div style="display:flex;align-items: center;" class="">
        							 		<span style="padding-right:4px;padding-left:8px;"><b>From:</b></span><datetime type='date' v-model="startdate" format="MMM dd, yyyy" input-class="form-control" value-zone="America/New_York"></datetime>
        							 		<span style="padding-right:4px;padding-left:8px;"><b>To:</b></span><datetime type='date' v-model="enddate" format="MMM dd, yyyy" input-class="form-control" value-zone="America/New_York"></datetime>
        							 	</div>
        							</div>
        							<div class="form-group mb-2" style="margin-left:10px;">
        								<model-select 
        									style="width:200px;"
        									:options="Accounts" 
        									v-model="account_id" 
        									placeholder="Choose a Account"> 
        								</model-select>
        							</div>
        							<button type="button" class="btn btn-success mb-2" style="margin-left:10px;" @click="FilterExpenses" >
        								<i class="fas fa-search"></i> Filter
        							</button>
        						</div>
        					</div>
        					<div class="col-2">
        						<div style="display:flex;justify-content: flex-end;">
        							<span class="cdropdown">
        								<button class="btn btn-transaction">Export As</button>
        								<label>
        									<input type="checkbox">
        									<ul class="text-left">
        										<li @click="generarPDF"><button><strong>PDF</strong></button></li>
        										<li @click="generarFiles('csv')"><button>CSV (Comma Separated Value)</button></li>
        										<li @click="generarFiles('xls')"><button>XLS (Microsoft Excel 1997 - 2004 Compatible)</button></li>
        										<li @click="generarFiles('xlsx')"><button>XLSX (Microsoft Excel)</button></li>
        									</ul>
        								</label>
        							</span>
        						</div>
        					</div>
        					<div class="col-12">
        						<Loader class="bgloading" v-if="isLoading"></Loader>
        						<div class="contenedor-table" id="expenses" v-else>      							
        							<table class="table table-striped table-bordered table-hover" >
        								<thead>
        									<tr>
        										<th>Exp #</th>
        										<th>Date</th>
        										<th>Vendor/Subcontractor</th>
        										<th>Account</th>
        										<th>Pmt Method</th>
        										<th style="text-align:center;">Status</th>
        										<th style="text-align:right;">Total</th>
        									</tr>
        								</thead>
        								<tbody>
        									<tr>
        										<td></td>
        										<td></td>
        										<td></td>
        										<td></td>
        										<td></td>
        										<td></td>
        										<td style="font-weight:bold;text-align:right;">${{ total | formatMoney }}</td>
        									</tr>
										    <tr v-if="noresult">
										    	<td colspan="3"><div style="text-align:center; color:red">No result</div></td>
										    </tr>
        									<tr v-for="i in ExpensesList" v-else>
        										<td>{{ i.numdoc }}</td>
        										<td>{{ i.fecha }}</td>
        										<td>
        											{{ i.subcon }}{{ i.ven }}
        										</td>
        										<td>{{ i.account }}</td>
        										<td>{{ i.formapago }}</td>
        										<td style="text-align:center;">
        											<span class="badge badge-success" v-if="i.status==1">PAID</span>
        											<span class="badge badge-danger" v-else="i.status==0">VOID</span>
        										</td>
        										<td style="text-align:right;">${{ i.totalExp | formatMoney }}</td>
        									</tr>
        								</tbody>
        								<tfoot>
        									<tr>
        										<th></th>
        										<th></th>
        										<th></th>
        										<th></th>
        										<th></th>
        										<th></th>
        										<th style="font-weight:bold;text-align:right;">${{ total | formatMoney }}</th>
        									</tr>
        								</tfoot>  
        							</table>
        						</div>
        					</div>
                        </div>
        			</div>
	            </div>
            </div>
        </div>
	</billing-layout>
</template>
<script>
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Loader from '@/components/shared/Loader'
import axios from 'axios'
import { ModelSelect } from 'vue-search-select'
export default {
	components:{
		Loader,
		BillingLayout,
		ModelSelect
    },
	name: 'ExpensesReport',
	data () {
		return {
			isLoading: false,
			dateFrom : new Date().toISOString(),
			dateTo : new Date().toISOString(),
			thisYear: null,
			thisMonth: null,
			SelectOne : 1,
			account_id:'',
			Accounts: [],
			ExpensesList: [],
			total: 0,
			startdate: new Date((new Date().toISOString()+'').slice(0,10)+'T06:00:00.000Z').toISOString(),
			enddate: new Date((new Date().toISOString()+'').slice(0,10)+'T06:00:00.000Z').toISOString(),
			noresult: false,
		}
	},
    watch:{
    	startdate: function(){
    		this.formatearFecha();
    		this.dateFrom =this.startdate;
    	},
    	enddate: function(){
    		this.formatearFecha();
    		this.dateTo =this.enddate;
    	}
    },
    created(){
    	this.getchartaccount();
    	this.FilterExpenses();
    },
    methods:{
        formatearFecha(){
        	this.startdate= new Date((new Date(this.startdate).toISOString()+'').slice(0,10)+'T06:00:00.000Z').toISOString();
        	if(this.enddate!=''){
        		this.enddate= new Date((new Date(this.enddate).toISOString()+'').slice(0,10)+'T06:00:00.000Z').toISOString();
        	}
        },
        getchartaccount(){
    		this.isLoading = true;
    		window.billing.get('expenses/account/' + window.localuserdata)
    		.then((response) => {
    			if(response.data.result.length > 0){
    				let  AccountList = [{value:'',text:'Alls Accounts'}];
    				for(let item in response.data.result){
    					let t = response.data.result[item].name_account;
    					AccountList.push({
    						value: response.data.result[item].id,
    						text: t,
    					}); 
    				};
    				this.Accounts= AccountList;
    				this.isLoading = false;
    			}
    		}).catch((error) => console.log(error));
	    },
	    generarFiles(type){
	    	this.$swal({
            	title: "Export",
            	text: "Export Report as "+type+" (Microsoft Excel)",
            	type: "info",
            	allowOutsideClick: false,
            	showCancelButton: true,
            	confirmButtonColor: "#3085d6",
            	cancelButtonText: 'Cancel',
            	confirmButtonText: "Export",
            	showLoaderOnConfirm: true,
            	preConfirm: () => {
	            	window.billing.post('report/export/expenses',{
	                    user_id: window.localuserdata,
	                    selecttype: this.SelectOne,
	                    account_id: this.account_id,
	                    dateFrom: this.dateFrom,
	                    dateTo: this.dateTo,
	                    filetype : type,
	                })
	                .then(response => {
	                    console.log(response.data);
	                    this.isLoading = false;
	                    window.open(window.urlbase+'files/'+response.data.result);                    
	                })
	                .catch(error => {
	                  this.$swal.showValidationMessage(
	                    `Request failed: ${error}`
	                  )
	                })
            	},
            	allowOutsideClick: () => !this.$swal.isLoading()
            })
            .then((result) => {
            	if (result.value) {
            		this.$swal.fire({
            			allowOutsideClick: false,
            			text: `Successfully downloaded`,
            			confirmButtonText: "Close",
            			showLoaderOnConfirm: true,
            			preConfirm: () => {
            				this.DeleteFile();
            			},
            		});
            	}
            });
        },
        DeleteFile(){
        	let name = 'expenses_report';
        	window.billing.get('report/expenses/deletefiles/'+ window.localuserdata +'/'+ name)
        	.then((response) => {
        		console.log(response.data.result);
        	}).catch((error) => console.log(error));
        },
        generarPDF(){
        	let user_id= window.localuserdata;
        	let selecttype= this.SelectOne;
        	let account_id= (this.account_id=='') ? 0 : this.account_id;
        	let dateFrom= this.dateFrom;
        	let dateTo= this.dateTo;
        	let uri = 'report/expenses/pdf/'+user_id+'/'+selecttype+'/'+account_id+'/'+dateFrom+'/'+dateTo;
        	window.open(window.urlbase+"api/v2/" + uri , "_blank");
        },
        FilterExpenses()
        {
        	this.isLoading = true;
        	window.billing.post('report/expenses',{
        		user_id: window.localuserdata,
        		selecttype: this.SelectOne,
        		account_id: this.account_id,
        		dateFrom: this.dateFrom,
        		dateTo: this.dateTo
        	})
        	.then((response) => {
        		console.log(response.data.result);
        		this.isLoading = false;
        		let e = response.data.result;
        		this.ExpensesList = e;
        		this.total = 0;
        		if(Object.keys(e).length > 0){
        			this.noresult = false;
        			for (let i in e) {
        				this.total+= parseFloat(e[i].totalExp);
        			}
        		}
        		else{this.noresult=true;}
            })
            .catch((error) => {
               console.log(error);
               this.isLoading = false
            });
        },
    }
};
</script>

<style lang="css" scoped>
</style>